// extracted by mini-css-extract-plugin
module.exports = {"readTimeContainer":"ReadTime_readTimeContainer__J3j1N","readTime":"ReadTime_readTime__1_Sx4","readTimeIcon":"ReadTime_readTimeIcon__M5Fbh"};